'use client'
import { format } from 'date-fns'
import React, { type LegacyRef } from 'react'

import type { ShareAbleTime } from '@/api/client/purchase/dto/purchaseDto'
import Button from '@/shared/components/button/Button'
import { Text } from '@/shared/components/typography'
import { formatTime } from '@/shared/utils/date'

import { roboto } from '@/styles/font'

const ExtendEnteringTime = ({
  onClickTimeValue,
  selectedIndex,
  time,
  onClickTimeNextBtn,
  enteringTime,
  contentHeight,
  footerRef,
  endTime
}: {
  time: ShareAbleTime[]
  selectedIndex: number | null
  onClickTimeValue: (i: number) => void
  onClickTimeNextBtn: () => void
  enteringTime: number
  handleSharedNoticeOpen: () => void
  contentHeight: number
  isSharedNoticeOpen: boolean
  footerRef: LegacyRef<HTMLDivElement>
  endTime: string
}) => {
  const generateExtendUsingEndTime = (time: ShareAbleTime['usingTime']) => {
    const now = new Date(endTime)
    const usingEndTime = format(new Date(now.getTime() + time * 60000), 'HH:mm')
    return `${usingEndTime}까지`
  }

  return (
    <>
      <div className={`flex flex-1 justify-center`} style={{ height: contentHeight, overflow: 'scroll' }}>
        <div className="flex flex-1 flex-col items-center bg-010 pt-4">
          <Text level="text1" color="text090" weight="bold">
            주차 시간을 선택해 주세요.
          </Text>
          <div className={`${roboto.className} mt-10 flex w-full flex-col bg-010 text-center`}>
            {time.map((item, i) => (
              <div
                key={i}
                className={`cursor-pointer py-[20px] ${selectedIndex === i ? 'bg-main-010 font-medium' : ''}`}
                onClick={() => onClickTimeValue(i)}
              >
                <Text level="text2" color="text090">
                  {`${formatTime(item.usingTime)}`}
                </Text>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={`sticky bottom-0 flex w-full flex-col gap-3 bg-010 px-4 py-3`}>
        <div className="flex flex-col items-center gap-1 rounded-md bg-020 pb-5 pt-6">
          <Text level="text2" color="text090" weight="bold">
            <span className={enteringTime ? 'text-main-050' : 'font-normal text-text-070'}>
              {enteringTime ? generateExtendUsingEndTime(enteringTime) : '종료 시간까지'}
            </span>{' '}
            주차 연장하기
          </Text>
        </div>
        <div className="sticky bottom-0" ref={footerRef}>
          <Button
            text="다음"
            color="text010"
            background="bg030"
            onClick={onClickTimeNextBtn}
            disabled={!enteringTime}
            className="body-1 h-[56px]"
            pyValue="py-0"
          />
        </div>
      </div>
    </>
  )
}

export default ExtendEnteringTime
